import { buildUrl, handleResponse } from "./auth";

const jsonHeaders = { "Content-Type": "application/json" };

export const getAdminEvents = () =>
  fetch(buildUrl("/api/admin/events"), {
    credentials: "include",
  }).then(handleResponse);

export const createAdminEvent = (payload) =>
  fetch(buildUrl("/api/admin/events"), {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify(payload ?? {}),
    credentials: "include",
  }).then(handleResponse);

export const updateAdminEvent = (eventId, payload) =>
  fetch(buildUrl(`/api/admin/events/${eventId}`), {
    method: "PUT",
    headers: jsonHeaders,
    body: JSON.stringify(payload ?? {}),
    credentials: "include",
  }).then(handleResponse);

export const deleteAdminEvent = (eventId) =>
  fetch(buildUrl(`/api/admin/events/${eventId}`), {
    method: "DELETE",
    credentials: "include",
  }).then(handleResponse);

export const uploadAdminEventImage = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return fetch(buildUrl("/api/admin/events/images"), {
    method: "POST",
    body: formData,
    credentials: "include",
  }).then(handleResponse);
};

export const getAdminEventTemplates = () =>
  fetch(buildUrl("/api/admin/events/templates"), {
    credentials: "include",
  }).then(handleResponse);

export const createAdminEventTemplate = (payload) =>
  fetch(buildUrl("/api/admin/events/templates"), {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify(payload ?? {}),
    credentials: "include",
  }).then(handleResponse);

export const updateAdminEventTemplate = (templateId, payload) =>
  fetch(buildUrl(`/api/admin/events/templates/${templateId}`), {
    method: "PUT",
    headers: jsonHeaders,
    body: JSON.stringify(payload ?? {}),
    credentials: "include",
  }).then(handleResponse);

export const deleteAdminEventTemplate = (templateId) =>
  fetch(buildUrl(`/api/admin/events/templates/${templateId}`), {
    method: "DELETE",
    credentials: "include",
  }).then(handleResponse);

export const addAdminEventAttendee = (eventId, payload) =>
  fetch(buildUrl(`/api/admin/events/${eventId}/attendees`), {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify(payload ?? {}),
    credentials: "include",
  }).then(handleResponse);

export const removeAdminEventAttendee = (eventId, bookingId) =>
  fetch(buildUrl(`/api/admin/events/${eventId}/attendees/${bookingId}`), {
    method: "DELETE",
    credentials: "include",
  }).then(handleResponse);

export const updateAdminEventAttendee = (eventId, bookingId, payload) =>
  fetch(buildUrl(`/api/admin/events/${eventId}/attendees/${bookingId}`), {
    method: "PUT",
    headers: jsonHeaders,
    body: JSON.stringify(payload ?? {}),
    credentials: "include",
  }).then(handleResponse);

const adminEventsApi = {
  getAdminEvents,
  createAdminEvent,
  updateAdminEvent,
  deleteAdminEvent,
  uploadAdminEventImage,
  getAdminEventTemplates,
  createAdminEventTemplate,
  updateAdminEventTemplate,
  deleteAdminEventTemplate,
  addAdminEventAttendee,
  removeAdminEventAttendee,
  updateAdminEventAttendee,
};

export default adminEventsApi;
